// HoldingCard — Holding row (Angel One light theme)
import React from 'react';
import PnLBadge from './PnLBadge';

export default function HoldingCard({ holding, onTrade }) {
  return (
    <div className="grid grid-cols-12 gap-2 px-4 py-2.5 border-b border-gray-100 hover:bg-gray-50 items-center text-xs group">
      <div className="col-span-2">
        <p className="font-medium text-gray-900">{holding.tradingsymbol}</p>
        <p className="text-[10px] text-gray-400">{holding.exchange}</p>
      </div>
      <div className="col-span-1 text-right font-mono text-gray-900">
        {holding.quantity}
      </div>
      <div className="col-span-2 text-right font-mono text-gray-900">
        ₹{parseFloat(holding.averageprice || 0).toFixed(2)}
      </div>
      <div className="col-span-2 text-right font-mono text-gray-900">
        ₹{holding.ltp?.toFixed(2) || '—'}
      </div>
      <div className="col-span-2 text-right font-mono text-gray-900">
        ₹{holding.investedValue?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || '—'}
      </div>
      <div className="col-span-2 text-right">
        <PnLBadge value={holding.pnl} size="sm" />
        <p className="text-[9px] text-gray-400 font-mono">{holding.pnlPercent?.toFixed(2)}%</p>
      </div>
      <div className="col-span-1 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          onClick={() => onTrade({
            instrument: {
              token: holding.symboltoken,
              symbol: holding.tradingsymbol,
              exchange: holding.exchange,
            },
            side: 'SELL',
          })}
          className="px-2.5 py-1 rounded text-[10px] font-bold bg-red-50 text-red-600 hover:bg-red-100"
        >
          SELL
        </button>
      </div>
    </div>
  );
}
